import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AppStorageService, KEYS_APPSTORAGE, NavigationService } from 'sce-core';

@Injectable()
export class isScreenAccess implements CanActivate {

  constructor(
    private navService: NavigationService, private appStorageService: AppStorageService) { }
    private accessibleMenuRoute = this.appStorageService.getItem(KEYS_APPSTORAGE.MENU_ROUTING)
  private menuIdAccessRouteExceptionalMappings: { [key: string]: string } = {
    'transaction/task': 'task',
    'supervisor-alerts/search/:searchId': 'supervisor-alerts',
    'transaction/rdt-data-capture': 'rdt-data-capture',
    'transaction/task/search/:searchId': 'task',
    'lot/search/:searchId': 'lot',
    'serial-number/search/:searchId': 'serial-number',
    'master-serial-number/search/:searchId': 'master-serial-number',
    'inventorybalance/:searchType/search/:searchId': 'inventorybalance',
    'empty-locations/search/:searchId': 'empty-locations',
    'transaction/rdt-data-capture/search/:searchId': 'rdt-data-capture',
    'view-report/search/:searchId': 'view-report',
    'inv-transactions/search': 'inv-transactions',
    'inv-transactions/search/:searchId': 'inv-transactions',
    'transaction/documentinfo': 'documentinfo',
    'transaction/documentinfo/search/:searchId': 'documentinfo',
    'non-inventory-items/search/:searchId': 'non-inventory-items',
    'ucc-maintenance/search/:searchId': 'ucc-maintenance',
    'abc-management/search/:searchId': 'abc-management',
    'abc-moves/search/:searchId': 'abc-moves',
    'pm-inventory/search/:searchId': 'pm-inventory',
    'pm-transactions/search/:searchId': 'pm-transactions',
    'inventory-moves/search': 'inventory-moves',
    'inventory-moves/search/:searchId': 'inventory-moves',
    'tm-inventory-move/search/:searchId': 'tm-inventory-move',
    'gtm-control/search/:searchId': 'gtm-control',
    'transmitlog/search/:searchId': 'transmitlog',
    'archive-parameters/search/:searchId': 'archive-parameters',
    'cartonization/search/:searchId': 'cartonization',
    'reason/search/:searchId': 'reason',
    'equipment/search/:searchId': 'equipment',
    'device/search/:searchId': 'device',
    'shift-setup/search/:searchId': 'shift-setup',
    'area/search/:searchId': 'area',
    'document-lookup/search/:searchId': 'document-lookup',
    'strategy/search/:searchId': 'strategy',
    'route-master/search/:searchId': 'route-master',
    'vehicle-information/search/:searchId': 'vehicle-information',
    'putaway-zones/search/:searchId': 'putaway-zones',
    'billofmaterial/search/:searchId': 'billofmaterial',
    'section/search/:searchId': 'section',
    'store-to-loc/search/:searchId': 'store-to-loc',
    'strategies/putaway-strategy': 'putaway-strategy',
    'channel-attribute-configuration/search/:searchId': 'channel-attribute-configuration',
    'channel-transfer/search/:searchId': 'channel-transfer',
    'case-manifest/search/:searchId': 'casemnifst',
    'channel-inventory-hold/search/:searchId':'channel-inventory-hold',
    'container-manifest/search/:searchId': 'container',
    'pallet-manifest/search/:searchId': 'pltmnifst',
    'inventorybalance/:searchType': 'inventorybalance',
    'strategies/appointment-strategy': 'appoint_strtgy',
    'strategies/door-booking-strategy': 'door_booking_strtgy',
  }
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      // Restrict routing to non permissible routes
    if (this.accessibleMenuRoute &&
      this.accessibleMenuRoute['routings'] && this.accessibleMenuRoute['routings'].length > 0 &&
      this.accessibleMenuRoute['routings'].indexOf(route.routeConfig.path) > 0) {
      return true;
    } else if(this.menuIdAccessRouteExceptionalMappings 
              && this.menuIdAccessRouteExceptionalMappings[route.routeConfig.path]
              && this.accessibleMenuRoute 
              && this.accessibleMenuRoute['routings'] 
              && this.accessibleMenuRoute['routings'].length > 0 
              && this.accessibleMenuRoute['routings'].indexOf(this.menuIdAccessRouteExceptionalMappings[route.routeConfig.path]) > 0){
      return true;
    }else {
      this.navService.navigateByMenuId('home');
      return false;
    }
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/guards/is-screen-access.ts